import { Icon, IconProps } from "@chakra-ui/react";

export function TextFileIcon(props: IconProps) {
  return (
    <Icon
      width="24px"
      height="24px"
      viewBox="0 0 56 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_421_821)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.10599 0C2.30399 0 0.0329895 2.272 0.0329895 5.074V58.915C0.0329895 61.718 2.30399 63.989 5.10599 63.989H50.88C53.681 63.989 55.954 61.718 55.954 58.915V20.31L37.051 0L5.10599 0Z"
          fill="#4389AD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.001 20.357V21.357H43.201C43.201 21.357 36.889 20.097 37.073 14.65C37.073 14.65 37.281 20.357 43.076 20.357H56.001Z"
          fill="#266D92"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.098 0.00598145V14.567C37.098 16.223 38.202 20.358 43.202 20.358H56.002L37.098 0.00598145Z"
          fill="white"
        />
        <path
          d="M16.598 39.144C16.226 39.144 15.938 39.042 15.734 38.838C15.542 38.622 15.446 38.328 15.446 37.956V28.236H11.936C11.624 28.236 11.378 28.152 11.198 27.984C11.03 27.804 10.946 27.564 10.946 27.264C10.946 26.952 11.03 26.718 11.198 26.562C11.378 26.394 11.624 26.31 11.936 26.31H21.26C21.572 26.31 21.812 26.394 21.98 26.562C22.16 26.718 22.25 26.952 22.25 27.264C22.25 27.564 22.16 27.804 21.98 27.984C21.812 28.152 21.572 28.236 21.26 28.236H17.75V37.956C17.75 38.328 17.654 38.622 17.462 38.838C17.27 39.042 16.982 39.144 16.598 39.144ZM23.9977 39.144C23.6977 39.144 23.4517 39.066 23.2597 38.91C23.0677 38.742 22.9537 38.538 22.9177 38.298C22.8937 38.046 22.9777 37.794 23.1697 37.542L27.2917 32.052V33.042L23.3677 27.786C23.1757 27.522 23.0917 27.27 23.1157 27.03C23.1397 26.778 23.2477 26.574 23.4397 26.418C23.6317 26.25 23.8717 26.166 24.1597 26.166C24.3997 26.166 24.6097 26.226 24.7897 26.346C24.9817 26.454 25.1737 26.64 25.3657 26.904L28.6057 31.368H27.8677L31.0897 26.904C31.2817 26.64 31.4677 26.454 31.6477 26.346C31.8397 26.226 32.0617 26.166 32.3137 26.166C32.6137 26.166 32.8597 26.244 33.0517 26.4C33.2437 26.556 33.3517 26.76 33.3757 27.012C33.3997 27.252 33.3097 27.51 33.1057 27.786L29.1817 33.042V32.052L33.2857 37.542C33.4777 37.794 33.5617 38.046 33.5377 38.298C33.5137 38.538 33.4057 38.742 33.2137 38.91C33.0217 39.066 32.7697 39.144 32.4577 39.144C32.2297 39.144 32.0197 39.084 31.8277 38.964C31.6477 38.844 31.4557 38.652 31.2517 38.388L27.8317 33.708H28.6237L25.2217 38.388C25.0297 38.652 24.8377 38.844 24.6457 38.964C24.4537 39.084 24.2377 39.144 23.9977 39.144ZM39.8714 39.144C39.4994 39.144 39.2114 39.042 39.0074 38.838C38.8154 38.622 38.7194 38.328 38.7194 37.956V28.236H35.2094C34.8974 28.236 34.6514 28.152 34.4714 27.984C34.3034 27.804 34.2194 27.564 34.2194 27.264C34.2194 26.952 34.3034 26.718 34.4714 26.562C34.6514 26.394 34.8974 26.31 35.2094 26.31H44.5334C44.8454 26.31 45.0854 26.394 45.2534 26.562C45.4334 26.718 45.5234 26.952 45.5234 27.264C45.5234 27.564 45.4334 27.804 45.2534 27.984C45.0854 28.152 44.8454 28.236 44.5334 28.236H41.0234V37.956C41.0234 38.328 40.9274 38.622 40.7354 38.838C40.5434 39.042 40.2554 39.144 39.8714 39.144Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_421_821">
          <rect width="56" height="64" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
}
